
define('text!locale/supported.json',[],function () { return '["en","fr"]';});
